<template>
  <div>
    <div  class="container">  </div>
  </div>
</template>

<script> 
  export default {
    data() {
      return {
          
      };
    },
    watch: {
  
    },
    created() {
   
    },

    mounted() {
     
    },
    methods: {
       

       
    }
  };

</script>



<style scoped>
  

</style>



// WEBPACK FOOTER //
// src/views/index.vue